<template>
<q-item
  v-show="latLng"
  clickable
  @click="showDialog = true"
>
  <q-item-section avatar>
    <q-avatar icon="warning"/>
  </q-item-section>
  <q-item-section>
    <q-item-label>{{ $t('tools.panoramasIncidence.notifyIncidence') }}</q-item-label>
  </q-item-section>
  <q-dialog v-model="showDialog" persistent>
    <q-card style="width: 450px">
      <q-card-section class="row items-center q-pt-md q-pb-xs">
        <q-icon name="warning" style="font-size: 1.5em;" class="q-pr-sm"/>
        <div class="text-h6 q-pr-xl">{{ $t('tools.panoramasIncidence.notifyIncidence') }}</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="showDialog = false" />
      </q-card-section>
      <q-card-section class="row items-center" v-if="$config.panoramas.incidence.description">
        <span v-html="$config.panoramas.incidence.description" />
      </q-card-section>
      <q-separator />
      <div class="q-pa-md">
        <q-select v-model="title" :options="incidenceOptions" :label="`${$t('tools.panoramasIncidence.incidenceType')}*`" />
        <div v-show="titleMissing" class="text-negative" style="font-size: 12px">{{ $t('tools.panoramasIncidence.requiredField') }}</div>
        <q-input v-model="description" autogrow :label="$t('tools.incidence.descriptionInput')"/>
        <div v-show="descriptionMissing" class="text-negative" style="font-size: 12px">{{ $t('tools.panoramasIncidence.descriptionMissing') }}</div>
        <q-input
          v-model="email"
          type="email"
          @blur="emailVerification"
          :label="`${$t('tools.incidence.emailInput')}*`"
        />
        <div v-show="emailError" class="text-negative" style="font-size: 12px">{{ $t('tools.incidence.emailErrorMessage') }}</div>
        <div v-show="emailMissing" class="text-negative" style="font-size: 12px">{{ $t('tools.panoramasIncidence.requiredField') }}</div>
        <div class="row q-pt-md">
          <q-space />
          <q-btn color="primary" :label="$t('tools.incidence.post')" :loading="loading" @click="send()" />
        </div>
      </div>
    </q-card>
  </q-dialog>
</q-item>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { QAvatar, QBtn, QCard, QCardSection, QDialog, QIcon, QInput, QSelect, QSeparator, QSpace, QItem, QItemSection, QItemLabel } from 'quasar'

export default {
  components: {
    QAvatar, QBtn, QCard, QCardSection, QDialog, QIcon, QInput, QSelect, QSeparator, QSpace, QItem, QItemSection, QItemLabel
  },
  // directives: {
  //   ClosePopup
  // },
  data () {
    return {
      description: null,
      descriptionMissing: false,
      email: null,
      emailError: false,
      emailMissing: false,
      incidenceOptions: this.$t('tools.panoramasIncidence.incidenceOptions'),
      loading: false,
      title: null,
      titleMissing: false,
      showDialog: false
    }
  },
  computed: {
    ...mapState({
      selectedCampaign: state => state.panorama.selectedCampaign,
      latLng: state => state.panorama.latLng,
      head: state => state.panorama.head
    })
  },
  methods: {
    t (key) {
      return this.$t('tools.incidence.' + key)
    },
    validateForm () {
      if (!this.title) {
        this.titleMissing = true
      } else if (this.title === 'Altres' && !this.description) {
        this.descriptionMissing = true
      }
      if (this.email) {
        this.emailError = this.emailVerification()
      } else {
        this.emailMissing = true
      }
      return !this.titleMissing && !this.descriptionMissing && !this.emailError && !this.emailMissing
    },
    send () {
      if (!this.validateForm()) {
        return
      }
      this.loading = true
      var content = {
        'user': null,
        'title': `Mapia STREETS - ${this.title}`,
        'description': `${this.description}\n\n${window.location.origin}${window.location.pathname}#/info/mapiastreets/${this.latLng.lat},${this.latLng.lng}/${this.head}`,
        'email': this.email,
        'geometry': {
          coordinates: [
            this.latLng.lng,
            this.latLng.lat
          ],
          type: 'Point'
        }
      }

      const contentJSON = JSON.stringify(content)
      const apiUrl = this.$config.incidence.url
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
      var config = {
        timeout: 10000,
        headers: headers
      }

      axios.post(apiUrl, contentJSON, config)
        .then(response => {
          this.$q.notify({
            message: this.$t('tools.incidence.message'),
            color: 'positive',
            position: 'top'
          })
          this.title = null
          this.description = null
          this.email = null
          this.loading = false
          this.showDialog = false
        }).catch(error => {
          this.$except(error)
          this.$q.notify({
            message: this.$t('tools.incidence.errorMessage'),
            color: 'warnign',
            position: 'top'
          })
          this.loading = false
        })
    },
    emailVerification () {
      // eslint-disable-next-line
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      if (this.email) {
        let valid = reg.test(this.email)
        if (valid) {
          return false
        } else {
          return true
        }
      }
    },
    restartErrors () {
      this.titleMissing = false
      this.descriptionMissing = false
      this.emailError = false
      this.emailMissing = false
    }
  },
  watch: {
    title () {
      this.restartErrors()
    },
    description () {
      this.restartErrors()
    },
    email () {
      this.restartErrors()
    },
    showDialog () {
      this.description = null
      this.descriptionMissing = false
      this.email = null
      this.loading = false
      this.emailError = false
      this.emailMissing = false
      this.title = null
      this.titleMissing = false
    }
  }
}
</script>

<style>

</style>
